import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import IconWithLabel from "app/pages/sales-intelligence/common-components/IconWithLabel/IconWithLabel";
import type { Translatable } from "app/pages/sales-intelligence/types";

import { StyledTimeFrameText } from "./styles";

type Props = {
    text: Readonly<Translatable>;
};

const SignalsTooltipTimeFrame = ({ text }: Props) => {
    return (
        <IconWithLabel
            iconName="daily-ranking"
            label={
                <I18n
                    translatable={text}
                    element={StyledTimeFrameText}
                />
            }
            dataAutomation="signals-tooltip-time-frame"
        />
    );
};

export default SignalsTooltipTimeFrame;
